import { useMutation } from '@tanstack/react-query'
import { logSentryError } from '@node-space/utils'
import {
  deleteNotificationDestination,
  DeleteNotificationDestinationRequest,
} from 'services/WebHooksService'
import { BaseErrorResponse } from 'types/beneficiaries'

export const useDeleteNotificationDestinationMutation = () => {
  return useMutation({
    mutationFn: (data: DeleteNotificationDestinationRequest) => deleteNotificationDestination(data),
    onError(error: BaseErrorResponse, data) {
      logSentryError('Error from useDeleteWebhookDestinationMutation', error, data)
    },
  })
}
